<template>
  <div></div>
</template>

<script>
import store from '../Store/store'

export default {
  name: 'Errors',

  data() {
    return {
      called: false
    }
  },

  computed: {
    errorObject() {
      return store.getters['errors/getErrorObject']
    }
  },

  watch: {
    errorObject(newErrorObj) {
      /**
       * NOTE this.called is used as a buffer to make sure error messages aren't rendered twice.
       * Please don't remove
       */
      if (!this.called) {
        this.$message(newErrorObj)
        this.called = true
      }

      setTimeout(() => {
        this.called = false
      }, 1000)
    }
  }
}
</script>
